import { useState } from "react";
import { faqs } from "@/mocks/guagua";
import SectionHead from "./SectionHead";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="scroll-mt-24 lg:scroll-mt-[132px] py-12 md:py-16">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <SectionHead kicker="CHIGUA·WENDA" title="吃瓜问答 FAQ" desc="关于每日吃瓜的栏目设置、事实核查与投稿方式，常问的问题都在这里。" align="center" />

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-background-200/60 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-medium text-[15px] text-foreground-950 flex items-center gap-3">
                    <span className={`shrink-0 w-7 h-7 rounded-full ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"} flex items-center justify-center text-xs font-bold`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-xl text-foreground-500 shrink-0`}></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[52px] text-sm text-foreground-600 leading-relaxed news-tab-fade">
                    <p>{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}